// extracted by mini-css-extract-plugin
export var errorIcon = "_nl-1";
export var nameLogo = "_nl-0";